<template>
	<div class="review">
		<div class="grid-columns-2">
			<div class="review-content">
				<div class="review-header">
					<div class="rating-stars">
						<TnRating
							:rating="rating.Rating"
							size="l"
						/>
					</div>
					<div class="margin-left-s">{{ rating.UserNickname }}</div>
					<TnIcon
						v-if="rating.Badges.verifiedPurchaser"
						class="margin-left-xs"
						color="#19AAF8"
						name="success-circle-filled"
						size="s"
					></TnIcon>
					<div class="margin-left-s">{{ submissionTime }}</div>
				</div>
				<h4>{{ rating.Title }}</h4>
				<p>{{ rating.ReviewText }}</p>
			</div>
			<div class="product-rating-categories">
				<div
					v-for="(secondaryRating, i) in rating.SecondaryRatings"
					:key="i"
					class="product-rating"
				>
					<h5>{{ secondaryRating.Label }}</h5>
					<TnProgressLinear
						:modelValue="secondaryRating.Value / secondaryRating.ValueRange"
						color="color-primary-telenor"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default defineNuxtComponent({
	props: ["rating"],

	computed: {
		submissionTime() {
			moment.locale("nb");
			return moment(this.rating.SubmissionTime).fromNow();
		},
	},
});
</script>

<style lang="scss" scoped>
.product-rating-categories {
	.product-rating {
		margin-bottom: $spacing-s;
	}

	h5 {
		margin-bottom: $spacing-xs;

		@include font-title-xs;
	}
}

.review-content {
	@include font-text-s;
}

.review {
	margin-top: $spacing-l;
	border-top: 1px solid #dbdbdb;
	padding-top: $spacing-l;
	display: flex;
	flex-direction: column;

	h4 {
		margin-bottom: $spacing-s;

		@include font-title-bold-m;
	}
}

.review-body {
	display: flex;
}

.review-header {
	display: flex;
	align-items: center;
	margin-bottom: $spacing-s;

	@include font-text-xs;
}
</style>
